// Slick JS
import 'slick-carousel/slick/slick.min';
  
if( $('html').attr('dir') === 'rtl' || $('body').hasClass('rtl') ) {
  //-------------------------- Arabic
  // SIMILAR NEWS SLIDER
  $('#similar-news-slider').slick({
    dots: true,
    slidesToScroll: 3,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    centerMode: false,
    rtl: true,
    responsive: [{
  
        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
  
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
  
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
} else {
  //------------------------- English
  // SIMILAR NEWS SLIDER
  $('#similar-news-slider').slick({
    dots: true,
    slidesToScroll: 3,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    centerMode: false,
    responsive: [{
  
        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
  
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
  
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
  
}